import { msg } from "@lingui/core/macro";

export const startOnDayOfWeekRuleMessages = {
	name: msg({ message: "Start On Day of Week" }),
	description: msg({ message: "Permit start date must fall on selected days of the week" }),
	errors: {
		invalidDay: msg({ message: "Permit must start on one of the selected days: {dayOfWeek}" }),
	},
} as const;
